import { render, staticRenderFns } from "./CampaignDetail.vue?vue&type=template&id=671d7a21&"
import script from "./CampaignDetail.vue?vue&type=script&lang=js&"
export * from "./CampaignDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports